import createReducer from '../createReducer'
import { parseLocationSuggestions, parseCitySuggestions } from '../shared/helpers'

import {
  GET_LOCATION_SUGGESTIONS_SUCCESS,
  SEARCH_FOR_CITY_SUCCESS,
} from './constants'

export const initialState = {
  locationSuggestions: [], // From Google API
  citySuggestions: [], // From Panama API
}

export default createReducer(initialState, {

  [GET_LOCATION_SUGGESTIONS_SUCCESS]: (state, action) => {
    const { payload } = action
    const locationSuggestions = parseLocationSuggestions(payload)

    return {
      ...state,
      locationSuggestions,
    }
  },

  [SEARCH_FOR_CITY_SUCCESS]: (state, action) => {
    const { payload } = action
    const citySuggestions = parseCitySuggestions(payload.data)

    return {
      ...state,
      citySuggestions,
    }
  },
})
